import { useEffect, useState } from "react";
import { Autocomplete, Box, Button, Divider, TextField, Typography } from "@mui/material";
import { useGetStations } from "hooks/useGetStations";
import membersService from "services/admin/membersService";
import { snack } from "components/Snack/Snack";

/**
 * Привязка оператора к станции. Управляется отдельно от формы сотрудника
 * через эндпоинты /members/:id/stations, чтобы не трогать createOrUpdateMember.
 * Один сотрудник ↔ одна станция.
 */
const OperatorStations = ({ memberID }: { memberID: string }) => {
  const orgID = localStorage.getItem("orgID") || "";
  const { data: stationsResponse } = useGetStations({ orgID });
  const stations = (stationsResponse as any)?.data || [];

  const [selected, setSelected] = useState<any>(null);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let active = true;
    membersService
      .getStation(memberID)
      .then((res: any) => {
        if (active) {
          setSelected(res?.data?.data || null);
          setLoaded(true);
        }
      })
      .catch(() => active && setLoaded(true));
    return () => {
      active = false;
    };
  }, [memberID]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await membersService.setStation(memberID, selected?.id ?? null);
      snack("Станция оператора сохранена");
    } catch (ex) {
      console.error(ex);
      snack("Не удалось сохранить станцию");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ mt: 4, maxWidth: 560 }}>
      <Divider sx={{ mb: 3 }} />
      <Typography variant="h6" sx={{ mb: 1 }}>
        Станция оператора (КТЖ)
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Оператор будет видеть только отправки своей станции: приёмка — по станции отправления,
        выдача — по станции назначения. Если станция не выбрана — сотрудник видит все отправки
        организации (роль менеджера/админа).
      </Typography>
      <Autocomplete
        options={stations}
        value={selected}
        getOptionLabel={(s: any) => s?.name || ""}
        isOptionEqualToValue={(o: any, v: any) => o?.id === v?.id}
        onChange={(_e, val) => setSelected(val)}
        renderInput={(params) => (
          <TextField {...params} label="Станция" placeholder="Выберите станцию" />
        )}
      />
      <Button variant="contained" sx={{ mt: 2 }} disabled={!loaded || saving} onClick={handleSave}>
        {saving ? "Сохранение..." : "Сохранить станцию"}
      </Button>
    </Box>
  );
};

export default OperatorStations;
